var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import { Radio as BaseRadio, useTheme } from "native-base";
const Radio = (_a) => {
    var { children, variant = "primary", value, size = "sm" } = _a, rest = __rest(_a, ["children", "variant", "value", "size"]);
    const { colors } = useTheme();
    const buttonVariants = useMemo(() => ({
        primary: colors.green[500],
        greenFilled: colors.green[500],
        orange: colors.orange[500],
        orangeFilled: colors.orange[500],
    }), [colors]);
    const bgVariants = useMemo(() => ({
        primary: "white",
        greenFilled: colors.green[100],
        orange: "white",
        orangeFilled: colors.orange[100],
    }), [colors]);
    return (_jsx(BaseRadio, Object.assign({ value: value, size: size, borderWidth: 1, bg: bgVariants[variant], borderColor: buttonVariants[variant], _checked: {
            bg: bgVariants[variant],
            borderColor: buttonVariants[variant],
            _icon: {
                color: buttonVariants[variant],
            },
            _hover: {
                borderColor: buttonVariants[variant],
            },
        }, _hover: {
            borderColor: buttonVariants[variant],
        } }, rest, { children: children })));
};
Radio.Group = BaseRadio.Group;
export default Radio;
